import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  icon: {
    width: theme.spacing(1.75),
    height: theme.spacing(1.75),
    fontSize: theme.spacing(1.75),
    padding: theme.spacing(0, 1.2, 0, 0),
  },
  text: {
    fontFamily: 'Poppins',
    fontSize: theme.spacing(1.75),
    fontWeight: 500,
    lineHeight: '20px',
    textAlign: 'center',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
    letterSpacing: '0.1px',
  },
  account: {
    fontFamily: 'Poppins',
    fontSize: theme.spacing(1.5),
    fontWeight: 400,
    lineHeight: '16px',
    textAlign: 'center',
  },
  copyIcon: {
    cursor: 'pointer',
    fontSize: theme.spacing(1.75),
  },
  currency: {
    color: theme.palette.textField.main,
    fontWeight: 400,
    fontSize: theme.spacing(1.5),
    lineHeight: '16px',
    textAlign: 'center',
  },
  renewalIcon: {
    width: theme.spacing(1.75),
    height: theme.spacing(1.75),
    fontSize: theme.spacing(1.75),
    padding: theme.spacing(0, 1.125, 0, 0),
  },
  renewalOffIcon: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    verticalAlign: 'middle',
    padding: theme.spacing(0, 1.125, 0, 0),
  },
  contractRed: {
    color: theme.palette.error.dark,
  },
  contractOrange: {
    color: '#CE8040',
  },
  name: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.spacing(1),
  },
  product: {
    color: theme.palette.textField.main,
    fontWeight: 400,
    fontSize: theme.spacing(1.5),
    lineHeight: '15px',
    textAlign: 'center',
  },
  buttonIcon: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(0.5),
    border: `1px solid ${theme.palette.textField.main}`,
  },
  tableWrapper: {
    borderTop: `1px solid ${theme.palette.divider}`,
    paddingTop: theme.spacing(2),
    marginTop: theme.spacing(-2),
  },
}))
